<template>
  <div>
    <el-row id="content-title">
      <el-col :span="24">
        <div class="d-flex align-items-center">
          <h3 class="mb-0">Batch Control</h3>
          <div class="ml-auto">
            <!-- <el-button
              type="primary"
              icon="el-icon-magic-stick"
              size="mini"
              @click="drawerState = true"
              >New Batch</el-button
            > -->
            <router-link
              class="el-button el-button--primary el-button--mini"
              :to="{ name: 'batch_info' }"
              title="Create new batch control"
              ><i class="el-icon-magic-stick"></i> New</router-link
            >
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <router-view :key="$route.fullPath"></router-view>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import POList from "@/views/purchaseorder/list.vue";
export default {
  name: "index",
  // components: { POList },
  computed: {
    hasActivePO() {
      return this.$store.getters["purchaseorder/active"].id;
    }
  },
  data() {
    return {
      drawerState: false
    };
  },
  mounted() {},
  methods: {
    openDrawer() {}
    // importPO() {
    //   this.drawerState = false;
    //   var po = this.$store.getters["purchaseorder/active"];
    //   // this.$router.push({ name: "batch_info", query: { po_id: po.id } });
    //   window.location.href = `/inventory/batch?po_id=${po.id}`;
    // }
  }
};
</script>

<style lang="css" scoped></style>
